import React from 'react';
import classNames from 'classnames';
import parse, { HTMLReactParserOptions } from 'html-react-parser';
import lm from './html.module.less';

const parseOption: HTMLReactParserOptions = {
  replace: (domNode: any) => {
    /**
     * <b>xxxxx</b>    加粗
     * <bc>xxxx</bc>   居中加粗
     * <bci>xxxx</bci> 居中加粗斜体
     * <bi>xxxxx</bi>  加粗斜体
    */

    try {
      if (domNode.name === 'b') {
        const children = domNode.children.map((child: any) => {
          if (!child.name) {
            return child.data;
          }
          // 构建子节点的HTML字符串并解析它
          let childHtml = `<${child.name}`;
          if (child.attribs) {
            Object.keys(child.attribs).forEach(attr => {
              childHtml += ` ${attr}="${child.attribs[attr]}"`;
            });
          }
          childHtml += '>';
          if (child.children && child.children.length > 0) {
            childHtml += child.children.map((c: any) => c.data || '').join('');
          }
          childHtml += `</${child.name}>`;
          return parse(childHtml);
        });
        return <span data-offset-start="3" data-offset-end="4" data-offset-all="7" className={lm.bold}>
          <span style={{ display: 'none' }}>{'<b>'}</span>
          {children}
          <span style={{ display: 'none' }}>{'</b>'}</span>
        </span>;
      }
      if (domNode.name === 'bc') {
        return <span data-disable="true" className={classNames(lm.bold, lm.center)}>
          <span style={{ display: 'none' }}>{'<bc>'}</span>
          {domNode.children[0].data}
          <span style={{ display: 'none' }}>{'</bc>'}</span>
        </span>;
      }
      if (domNode.name === 'bi') {
        return <span data-disable="true" className={classNames(lm.bold, lm.italic)}>
          {domNode.children[0].data}
        </span>;
      }
      if (domNode.name === 'bci') {
        return <span data-disable="true" className={classNames(lm.bold, lm.center, lm.italic)}>
          {domNode.children[0].data}
        </span>;
      }
      if (domNode.name === 'bi-inline') {
        return <span className={classNames(lm.bold, lm.italic)}>{domNode.children[0].data}</span>;
      }
      if (domNode.name === 'iu') {
        return <span className={classNames(lm.under, lm.italic)}>
          <span style={{ display: 'none' }}>{'<iu>'}</span>
          {domNode.children[0].data}
          <span style={{ display: 'none' }}>{'</iu>'}</span>
        </span>;
      }
      if (domNode.name === 'divider') {
        return <span className={classNames(lm.divider)}>
          <span style={{ display: 'none' }}>{'<divider/>'}</span>
        </span>;
      }
      if (domNode.name === 'static-w') {
        return <span data-disable="true" className={classNames(lm.static_w, lm.bold, lm.italic)}>{domNode.children[0].data}</span>;
      }
    } catch (e) {}
  },
};

function MyComponent({ htmlString = '' }: {htmlString: string| number | undefined;}) {

  return (
    <>
      {parse(String(htmlString), parseOption)}
    </>
  );
}

export default MyComponent;

const isAllUpperCase = (str: string) => {
  // 检查字符串是否匹配所有字符都是大写字母的正则表达式
  return /^[A-Z/,.\-]+$/.test(str);
};

const getParts = (str: string): string[] => {
  return str.split(/ |&nbsp/g);
};

export const innerBold = (str: string) => {
  // return str.split(/(\s|&nbsp)/).map(s => {
  return getParts(str).map(s => {
    return isAllUpperCase(s) ? `<bi-inline>${s}</bi-inline>` : s;
  }).join(' ');
};

function markWidth(text: string) {
  // 定义要查找的关键词的正则表达式模式
  const pattern = /\b(TRUE|FALSE|YES|NO|NOT GIVEN|Example|Paragraph [A-Za-z]|Section [A-Za-z]|Key Point One)\b/g;

  // 使用replace()函数替换文本中的关键词为<w>keyword</w>的形式
  const markedText = text.replace(pattern, '<static-w>$1</static-w>');
  return markedText;
}

export const innerWidth = (str: string) => {
  return markWidth(str);
};